import React from "react";
import { List } from "antd";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import IndicaCar from "../../../assets/images/Indica-car-img.png";

import seatsicon from "../../../assets/images/seats-icon.png";
import acicon from "../../../assets/images/ac-icon.png";
import autoicon from "../../../assets/images/auto-icon.png";
import petrolicon from "../../../assets/images/petrol-icon.png";

//for redux and saga
import { connect } from 'react-redux';
import { getOurVehicle } from '../../../redux/actions';

const OurVehicles = (props) => {
  var settings = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const { getOurVehicleAction, getOurVehicleList, loading, error, messages } = props

  console.log("check---", getOurVehicleList, loading, error, messages)

  React.useEffect(() => {
    // alert('calld')
    fetchData()
  }, [])

  const fetchData = () => {
    // alert("hello")
    getOurVehicleAction(1)
  }
 
  return (
    <>
    {getOurVehicleList.length > 0 ?
    <section className="our-vehicles pt-100 pb-70">
      <Container>
        <Row>
          <Col md={12}>
            <h2 className="main-title">
            Get rid of your gestalt proximity now and have your travel check.
            </h2>
            <p className="sub-title">
              At <b>Skycars</b>, we provide you with a range of cars in the
              fleet, to choose from. Our fleet includes the{" "}
              <b>
                most spacious of cars and fits more than 5 passengers. Some of
                the most demanded vehicles are:
              </b>
            </p>
          </Col>
        </Row>
        <Row className="justify-content-center pt-30">
          <Col md={12}>
            <Slider {...settings}>
            {getOurVehicleList && getOurVehicleList.map((item) => (
              <div>
                <div className="our-vehicles-box">
                  <h2>{item.CarName}</h2>
                  <img src={IndicaCar} alt={item.CarName} />{" "}
                  <h3>
                    <b>₹{item.DailyCharge}</b>/ Day
                  </h3>
                  <List>
                    <List.Item>
                      <span>
                        <img src={seatsicon} alt="" />
                      </span>
                      <h5>{item.SeatingCapacity} Seats</h5>
                    </List.Item>
                    {item.IsAC === true
                    ? <List.Item>
                      <span>
                        <img src={acicon} alt="" />
                      </span><h5>AC</h5>
                    </List.Item>
                    : <List.Item><span>
                      <img src={acicon} alt="" />
                      </span><h5>NON-AC</h5></List.Item>
                    }
                    <List.Item>
                      <span>
                        <img src={autoicon} alt="" />
                      </span>
                      <h5>Auto</h5>
                    </List.Item>
                    <List.Item>
                      <span>
                        <img src={petrolicon} alt="" />
                      </span>
                      <h5>{item.CarFuelName}</h5>
                    </List.Item>
                  </List>
                </div>
              </div>
            ))}
            </Slider>
          </Col>
        </Row>
        
      </Container>
      
    </section>
    :<section>

    </section>
    }
    </>
  );
};

//   export default HowitWork;
const mapStateToProps = ({ ourvehicle }) => {
  // console.log('======', howitwork);
  const { loading, error, messages, getOurVehicleList } = ourvehicle;
  return { loading, error, messages, getOurVehicleList };
};

export default connect(mapStateToProps, {
  getOurVehicleAction: getOurVehicle,
})(OurVehicles);
